'use client';

import { HelmetProvider } from '@dr.pogodin/react-helmet';

const HelmetProviderWrapper = ({ children }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default HelmetProviderWrapper;
